/* ---------- data ---------- */
const TIERS=[
  {t:"BUY ONE",qty:1,price:58.95,cmp:79.95,img:"https://cdn.shopify.com/s/files/1/0828/2344/6753/files/bundle_1_d4a81dc4-3874-4ba4-9478-bb514cb14e1c.webp?v=1782308119",sub:"Universal holster + adapter"},
  {t:"BUY TWO — SAVE 37%",qty:2,price:100.22,cmp:159.90,img:"https://cdn.shopify.com/s/files/1/0828/2344/6753/files/bundle_2_d21ecfac-4e2a-4b7c-8951-44e444b46342.webp?v=1782308119",sub:"2 holsters + 2 adapters"},
  {t:"BUY 3 + 1 FREE",qty:4,price:176.85,cmp:319.80,img:"https://cdn.shopify.com/s/files/1/0828/2344/6753/files/bundle_3_434311d7-e284-4ae1-b0ae-60bd56bed9d1.webp?v=1782308119",sub:"4 holsters + 4 adapters"}
];
let sel=0;
const $=id=>document.getElementById(id);
const money=v=>"$"+v.toFixed(2);

/* ---------- countdown (daily evergreen) ---------- */
setInterval(()=>{const n=new Date(),e=new Date(n);e.setHours(23,59,59,999);
let s=Math.max(0,Math.floor((e-n)/1000));
const p=x=>String(x).padStart(2,"0");
$("cd").textContent=p(Math.floor(s/3600))+":"+p(Math.floor(s%3600/60))+":"+p(s%60);},250);

/* ---------- arrival date ---------- */
(()=>{const d=new Date();d.setDate(d.getDate()+3);   // matches the FAQ promise: 2-3 days within the U.S.
$("arrive").textContent=d.toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric"});})();

/* ---------- gallery ---------- */
const IMGS=["1_c5d2a6ef-0b19-4182-9d39-164542a42c75.webp?v=1782413886","2_afc2545d-ab92-4bb2-bf9d-6e4afd53687c.webp?v=1782413971","4_e96867ff-c662-488a-82dc-7155edaf7135.webp?v=1782508027","5_1a9485c3-19de-4768-87c9-e4214784608a.webp?v=1782508027","7.webp?v=1782413886","8.webp?v=1782413886"].map(n=>"https://cdn.shopify.com/s/files/1/0828/2344/6753/files/"+n);
let gi=0;
const tb=$("thumbs"),gtrack=$("gtrack");
IMGS.forEach(s=>{const sl=document.createElement("div");sl.className="gslide";
const im=new Image();im.src=s;im.draggable=false;im.alt="TACFENDER Universal Holster";sl.appendChild(im);gtrack.appendChild(sl);});
IMGS.forEach((s,i)=>{const im=new Image();im.src=s;im.draggable=false;im.alt="TACFENDER Universal Holster — view "+(i+1);im.onclick=()=>gset(i);tb.appendChild(im);});
function gset(i,animate){gi=Math.max(0,Math.min(IMGS.length-1,i));
gtrack.style.transition=animate===false?"none":"";
gtrack.style.transform="translateX(-"+(gi*100)+"%)";
[...tb.children].forEach((t,j)=>t.classList.toggle("on",j===gi));}
gset(0,false);

/* drag / swipe — no arrows, just grab the image and slide it */
let gDown=false,gStartX=0,gDeltaX=0,gW=1;
function gStart(e){gDown=true;gDeltaX=0;gStartX=(e.touches?e.touches[0]:e).clientX;gW=gtrack.parentElement.getBoundingClientRect().width||1;gtrack.style.transition="none";}
function gMove(e){if(!gDown)return;const x=(e.touches?e.touches[0]:e).clientX;gDeltaX=x-gStartX;
let resist=1;if((gi===0&&gDeltaX>0)||(gi===IMGS.length-1&&gDeltaX<0))resist=0.35;
gtrack.style.transform="translateX("+((-gi*100)+(gDeltaX*resist/gW*100))+"%)";}
function gEnd(){if(!gDown)return;gDown=false;gtrack.style.transition="";
const threshold=gW*0.16;
if(gDeltaX<-threshold&&gi<IMGS.length-1)gset(gi+1);
else if(gDeltaX>threshold&&gi>0)gset(gi-1);
else gset(gi);
gDeltaX=0;}
gtrack.addEventListener("pointerdown",gStart);
gtrack.addEventListener("pointermove",gMove);
addEventListener("pointerup",gEnd);
addEventListener("pointercancel",gEnd);

/* ---------- tiers ---------- */
function pick(i){sel=i;
document.querySelectorAll(".tier").forEach((t,j)=>t.classList.toggle("on",j===i));
const T=TIERS[i];
$("bigprice").textContent=money(T.price);$("bigcmp").textContent=money(T.cmp);
$("bigsave").textContent="YOU SAVE "+money(T.cmp-T.price)+" TODAY";
$("stp").textContent=money(T.price);$("stc").textContent=money(T.cmp);
/* la barra sticky debe decir QUÉ se añade: con el pack de 4 seleccionado mostraba
   $176.85 junto a "TACFENDER UNIVERSAL HOLSTER", que se lee como un holster carísimo */
const sn=$("stname");
if(sn)sn.textContent=T.qty===1?"TACFENDER UNIVERSAL HOLSTER":"TACFENDER — "+T.qty+" HOLSTERS";}
pick(0);

/* ---------- accordions ---------- */
function accInit(root,single){if(!root)return;/* guard: sin esto, un id que ya no existe lanza y MATA todo el resto del archivo — incluido VARIANT_ID y el add-to-cart. Paso 2026-08-04 al quitar #faqacc. */root.querySelectorAll(".it .q").forEach(q=>{
q.onclick=()=>{const it=q.parentElement,was=it.classList.contains("open");
if(single)root.querySelectorAll(".it").forEach(x=>{x.classList.remove("open");x.querySelector(".a").style.maxHeight=null;});
if(!was){it.classList.add("open");const a=it.querySelector(".a");a.style.maxHeight=a.scrollHeight+"px";}
else{it.classList.remove("open");it.querySelector(".a").style.maxHeight=null;}};});
const o=root.querySelector(".it.open .a");if(o)o.style.maxHeight=o.scrollHeight+"px";}
accInit($("bacc"),true); /* #faqacc se eliminó al sustituir la FAQ vieja por snippets/tf-faq-product.liquid */

/* ---------- marquee: seed until >= viewport, then exact twin for seamless -50% loop ---------- */
(()=>{const mt=$("mtrack");const base=mt.innerHTML;let html=base;mt.innerHTML=html;
while(mt.scrollWidth<Math.max(innerWidth,900)){html+=base;mt.innerHTML=html;}
mt.innerHTML=html+html;
mt.style.animationDuration=(mt.scrollWidth/2/40)+"s";})();

/* ---------- video boxes: match container to real aspect ratio (no black bars) ---------- */
document.querySelectorAll('.vid video').forEach(v=>{
  const fit=()=>{if(!v.videoWidth)return;const r=v.videoWidth/v.videoHeight,box=v.closest('.vid');
    box.style.aspectRatio=v.videoWidth+' / '+v.videoHeight;
    if(r<1)box.style.maxWidth=2*Math.round(Math.min(520,r*720)/2)+'px';};
  v.readyState>=1?fit():v.addEventListener('loadedmetadata',fit);
});

/* ---------- reveal ---------- */
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}}),{threshold:.12});
document.querySelectorAll(".rv").forEach(el=>io.observe(el));
/* RED DE SEGURIDAD. El 2026-08-04 un error anterior en este archivo impidio crear el
   observer y dejo las 13 secciones a opacity:0 — la pagina entera invisible, con el
   contenido presente en el DOM pero sin ver. Este fallback garantiza que el peor caso
   sea "sin animacion" en vez de "sin pagina":
   1) al cargar, revela lo que ya quedo por encima del viewport (p.ej. al entrar con #faq),
      que de otro modo no se animaria nunca;
   2) a los 4s revela cualquier .rv que siga oculto y este a la vista. */
(function(){
  var reveal=function(el){el.classList.add("in");};
  var pass=function(margin){
    document.querySelectorAll(".rv:not(.in)").forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.bottom < 0 || r.top < innerHeight*margin) reveal(el);
    });
  };
  if(location.hash) setTimeout(function(){pass(1);},400);
  setTimeout(function(){pass(1.2);},4000);
})();

/* ---------- sticky bar ----------
   Antes: se mostraba solo cuando TODO el #buybox había pasado (acordeón incluido).
   Eso dejaba ~780px de scroll sin ningún CTA en pantalla — los primeros ~470px, con el
   CTA principal todavía bajo el fold, y otros ~310px después de pasarlo. Justo la zona
   de mayor intención de compra.
   Ahora: se muestra siempre que el CTA principal NO esté visible y el usuario haya
   empezado a bajar. Así hay un camino de un toque a añadir al carrito en toda la página,
   sin tapar el hero al entrar. */
const ctaMain=document.querySelector("#buybox .cta");
/* guard: si alguien cambia el markup y este selector deja de encontrar el botón,
   sin esto getBoundingClientRect() lanzaría en CADA evento de scroll y podría
   arrastrar consigo otros listeners de la página. Con el guard, el peor caso es
   que la barra sticky no aparezca — la landing sigue funcionando. */
if(ctaMain){
  addEventListener("scroll",()=>{
    const r=ctaMain.getBoundingClientRect();
    const ctaVisible=r.top<innerHeight&&r.bottom>0;
    $("sticky").classList.toggle("show",scrollY>240&&!ctaVisible);
  },{passive:true});
}

/* ---------- cart: REAL add-to-cart -> theme drawer (fp-cart.js) ---------- */
const VARIANT_ID = (window.__fpIds && window.__fpIds.holster) || 48461273497825;   // TACFENDER Universal Holster (single variant)
let tfBusy = false;
/* A/B test concluded 2026-07-30 (B won) — B is now the ONLY landing, so stamp 'B'
   unconditionally. Reading the old cookie would mis-stamp returning visitors as 'A'
   (that cookie lives 90 days) even though everyone now sees this landing. */
function stampAB(){
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
    body: JSON.stringify({attributes:{tf_ab:'B'}})}).catch(()=>{});
}
/* Abre el cart drawer SIN hacer click en #cart-icon-bubble. Ese icono es un
   <a href="/cart"> anclado arriba del todo: simular el click lo enfoca y el navegador
   arrastra la pagina al top, asi que el usuario perdia su posicion al comprar desde la
   barra sticky. fp-cart.js registra <cart-drawer> con .open(), asi que lo llamamos
   directo. Se conserva el click como fallback por si el drawer no estuviera registrado. */
function openCart(msg){
  var d=document.querySelector("cart-drawer");
  if(d&&typeof d.open==="function"){d.open();return;}
  var b=document.getElementById("cart-icon-bubble")||document.querySelector(".header__icon--cart");
  if(b)b.click();else toast(msg);
}
function addToCart(){
  if(tfBusy) return; tfBusy = true;
  const T = TIERS[sel];
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
    body: JSON.stringify({id:VARIANT_ID, quantity:T.qty})})
    .then(r=>r.json())
    .then(res=>{tfBusy=false;
      if(res && res.status){toast('Could not add to cart — please retry');return;}
      if(typeof gtag==='function'){try{gtag('event','add_to_cart',{tf_ab:'B',quantity:T.qty});}catch(e){}}
      stampAB();
      openCart('Added to cart ✔');
    })
    .catch(()=>{tfBusy=false;toast('Network error — please retry');});
}
function toBuy(){scrollTo({top:0,behavior:"smooth"});}

/* ---------- Ultimate Holster Bundle: separate product, own add-to-cart ---------- */
const BUNDLE_VARIANT_ID = (window.__fpIds && window.__fpIds.bundle) || 48637792813281;
let bundleBusy = false;
function addBundleToCart(){
  if(bundleBusy) return; bundleBusy = true;
  const btn = document.getElementById('bundleCta');
  if(btn) btn.disabled = true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
    body: JSON.stringify({id:BUNDLE_VARIANT_ID, quantity:1})})
    .then(r=>r.json())
    .then(res=>{bundleBusy=false; if(btn) btn.disabled=false;
      if(res && res.status){toast('Could not add bundle — please retry');return;}
      if(typeof gtag==='function'){try{gtag('event','add_to_cart',{tf_ab:'B',item:'ultimate_bundle'});}catch(e){}}
      stampAB();
      openCart('Bundle added to cart ✔');
    })
    .catch(()=>{bundleBusy=false; if(btn) btn.disabled=false; toast('Network error — please retry');});
}
let tt;function toast(m){const t=$("toast");t.textContent=m;t.classList.add("show");clearTimeout(tt);tt=setTimeout(()=>t.classList.remove("show"),2600);}
